<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <div class="flex flex-col gap-1">
      <span class="flex justify-start items-center text-black font-black uppercase">Temas</span>
      <span class="text-sm text-gray-600">
        Escolha um parceiro e clique em "Editar temas" para configurar logos, cores, textos e animações dos totens e do
        app.
      </span>
    </div>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label=".form-select-lg"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of listOrder" [value]="order.value">{{ order.label }}</option>
      </select>

      <div>
        <input
          [formControl]="acaoInput"
          type="text"
          class="form-input w-64"
          placeholder="Pesquise pelo nome do parceiro"
        />
      </div>
      <div class="flex justify-between">
        <button (click)="filterPartner()" title="Buscar parceiro" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          (click)="clearfilters()"
          title="Limpar Filtros"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
        <!-- <button *isAllowed="[ERoleAdminString.Admin]"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine" title="Download Excel com Empresas"
          (click)="downloadExcel()">
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button> -->
      </div>
    </div>
  </div>

  <app-list-partners-settings
    [partners]="partners"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="loadPartners()"
  ></app-list-partners-settings>
</form>
